import axios from 'axios';
import buildPaginationQueryOpts from '@/shared/sort/sorts';

export default class EmailCampaignService {
  public get(id: number): Promise<any> {
    return axios.get(`api/email-weekly-statistics/${id}`);
  }

  public send(emailCampaign): Promise<any> {
    return axios.post('api/send/email-weekly-statistics', emailCampaign);
  }

  public update(user): Promise<any> {
    return axios.put('api/users', user);
  }

  public approved(id: number): Promise<any> {
    return axios.get(`api/update/email-weekly-statistics/${id}?state=APPROVED`);
  }

  public remove(id: number): Promise<any> {
    return axios.delete(`api/email-weekly-statistics/${id}`);
  }

  public retrieve(req?: any, flag?: any, paginateStaring?: any): Promise<any> {
    var strQ = `state=${req.state}&offerName=${req.offerName}&offerType=${req.offerType}&merchantName=${req.merchantName}`;

    if (flag == 'pending') {
      return axios.get(`api/email-weekly-statistics?${strQ}&${buildPaginationQueryOpts(paginateStaring)}`);
    } else {
      return axios.get(`api/email-weekly-statistics?${strQ}&${buildPaginationQueryOpts(paginateStaring)}`);
    }
  }

  public retrieveAuthorities(): Promise<any> {
    return axios.get('api/users/authorities');
  }

  public retrieveCountries(): Promise<any> {
    return axios.get('/api/public/settings/countries');
  }
}
